<footer class="footer">
  <div class="footer-container">
    <!-- Desktop Layout -->
    <div class="footer-desktop">
      <div class="footer-brand">
        <div class="footer-logo">
          <img src="assets/images/logo-reserva-de-espacios-horizontal-blanco.png" alt="Reserva de espacios" />
        </div>
        <p class="footer-tagline">TU CIUDAD, TUS MOMENTOS, TUS ESPACIOS.</p>
      </div>
      <div class="footer-divider"></div>
      <nav class="footer-nav" aria-label="Enlaces del pie de página">
        <a routerLink="/privacidad">PRIVACIDAD</a>
        <a routerLink="/terminos-y-condiciones">TÉRMINOS Y CONDICIONES</a>
        <a routerLink="/aviso-legal">AVISO LEGAL</a>
        <a routerLink="/cookies">COOKIES</a>
      </nav>
      <div class="footer-divider"></div>
      <div class="footer-copyright">
        <p>&copy; {{ currentYear }} Reserva de Espacios.</p>
        <p>Kreare Digital S.L.</p>
      </div>
    </div>

    <!-- Mobile Layout -->
    <div class="footer-mobile">
      <div class="footer-brand">
        <div class="footer-logo">
          <img src="assets/images/logo-reserva-de-espacios-horizontal-blanco.png" alt="Reserva de espacios" />
        </div>
        <p class="footer-tagline">TU CIUDAD, TUS MOMENTOS, TUS ESPACIOS.</p>
      </div>
      <div class="footer-divider"></div>
      <nav class="footer-nav" aria-label="Enlaces del pie de página">
        <a routerLink="/privacidad">PRIVACIDAD</a>
        <a routerLink="/terminos-y-condiciones">TÉRMINOS Y CONDICIONES</a>
        <a routerLink="/aviso-legal">AVISO LEGAL</a>
        <a routerLink="/cookies">COOKIES</a>
      </nav>
      <div class="footer-divider"></div>
      <div class="footer-copyright">
        <p>&copy; {{ currentYear }} RESERVA DE ESPACIOS</p>
        <p>KREARE DIGITAL S.L.</p>
      </div>
    </div>
  </div>
</footer>
